import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';
import axios from 'axios';
import fpodb from '../../../db.json';
import VModal from 'vue-js-modal';
import {releaseNotesModal} from './modals';
import { Accordion, SelectedFiltersComponent, Checkbox, Pagination } from './filter-components';

const safeString = (str) => {
    return encodeURIComponent(str);
}

const Software = () => {

    let software = document.querySelectorAll('.software');
    Vue.use(VModal);

    const softwareConstructor = (id) => {
        Vue.component('software-template', {
            data: function() {
                return {
                    data: {
                        currentPage: 1, //current page #
                        totalPages: null, //total returns pages
                        totalResults: null, //total results
                        shownResults: null, //total shown items
                        filtersVisible: null, //are filters visible
                        filterAreaVisible: true,
                        filters: [],
                        products: [],
                        results: [],
                        savedDocs: [], //bookmarked items
                        savedDocsLabel: null, //label for saved docs
                        savedDocsOnly: null, //is saved docs only checked
                        isMobile: null,
                        nextActive: null,
                        prevActive: null,
                        // apiUrl: null, //for api call
                        urlParams: null, //for deeplinking in-browser
                        // store: store
                        query: null,
                        releaseNotesLabel: null,
                        class: 'software',
                        trackingType: 'app'
                    },
                    isLoading: null
                }
            },
            components: {
                'filter-accordion-template': Accordion,
                'selectedFilters': SelectedFiltersComponent,
                'checkbox-item': Checkbox,
                'pagination': Pagination
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                },
                saved: function() {
                    return store.state.favorites.softwareId[0] == "" ? store.state.favorites.softwareId.slice(1) : store.state.favorites.softwareId;
                },
                pageRange: function() {
                    if (this.data.totalResults > 10) {
                        if (this.data.currentPage == 1) {
                            return `1-${this.data.shownResults}`;
                        } else if (this.data.currentPage == this.data.totalPages ) {
                            return `${this.data.totalResults - this.data.shownResults + 1}-${this.data.totalResults}`;
                        } else {
                            return `${(this.data.shownResults * (this.data.currentPage - 1)) + 1}-${this.data.shownResults * this.data.currentPage}`;
                        }
                    } else {
                        return this.data.shownResults;
                    }
                },
                siteLang: function() {
                    return store.state.currentLang;
                }

            },
            watch: {
                saved: function() {
                    this.data.savedDocs = this.saved;

                    // remove saved only filter if no saved items
                    if (this.saved.length == 0) {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf('savedDownloads');
                        if (index > -1) {
                            this.data.filters.splice(index,1);
                        }
                    }
                },
                computedIsMobile: function() {
                    this.data.isMobile = this.computedIsMobile;
                    this.data.filtersVisible = !this.computedIsMobile ? true : this.data.filtersVisible;
                },
                "data.filters": function() {
                    this.addLoading();
                    this.getResults(); // handle api call
                    // this.updateHistory(); // handle history record
                    // this.data.currentPage = 1; //reset page to 1

                    // check for if productline is selected
                    let productLines = this.data.filters.filter(el => {
                        return el.type == "productline";
                    }).map(el => {
                        return el.value;
                    });

                    // set savedDocsOnly value
                    let savedOnly = this.data.filters.find(item => {
                        return item.type == "savedSoftware";
                    })
                    this.data.savedDocsOnly = savedOnly ? savedOnly.value : null;


                    if (productLines.length > 0) {
                        this.populateProducts(productLines); 
                    } else {
                        //if not brand selected, empty the products array
                        this.data.products = []; 
                        // remove selected product filters
                        this.data.filters.filter(el => {
                            return el.type == "product"
                        }).forEach(item => {
                            this.removeFilter(this.data.class, item.value);
                        });
                    }
                },
                "data.currentPage": function() {
                    if (this.data.currentPage == 1) {
                        this.data.nextActive = true;
                        this.data.prevActive = false;
                    } else if (this.data.currentPage == this.data.totalPages) {
                        this.data.nextActive = false;
                        this.data.prevActive = true;
                    } else {
                        this.data.nextActive = true;
                        this.data.prevActive = true;
                    }

                    // this.getResults();
                    // this.updateHistory();
                },
                "data.totalResults": function() {
                    this.initPages();
                }
            },
            methods: {
                toggleFilters() {
                    // console.log("clicked");
                    if (this.data.isMobile) {
                        // console.log("is mobile");
                        this.data.filtersVisible = !this.data.filtersVisible;
                    }
                },
                updateFilters(el, e, type) {
                    if (el !== this.data.class) {
                        return;
                    }

                    var type = type;
                    var value = safeString(e.currentTarget.value);
                    var label = e.currentTarget.parentNode.innerText;
                    var checked = e.currentTarget.checked;
                    this.data.currentPage = 1;//reset page to 1 when new filters added/removed
                    // console.log("type", type)
                    // console.log(e);
                    // console.log("value", safeString(e.target.value));
                    // console.log("checked",e.target.checked);

                    if (checked) {
                        if (type !== "savedSoftware") {
                            this.data.filters = [...this.data.filters, {"value": value, "type": type, "name": label}];
                        } else {
                            this.data.filters = [...this.data.filters, {"value": checked, "type": type, "name": label}];
                        }
                    } else {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf(value);
                        // console.log("INDEX", index);
                        this.data.filters.splice(index,1);
                    }
                },
                // removes specific filter
                removeFilter(el, value, type) {
                    if (el !== this.data.class) {
                        return;
                    }
                    let index = this.data.filters.map((e) => {
                        return e.value
                    }).indexOf(value);
                    this.data.filters.splice(index,1);
                },
                // clears filters
                removeAll() {
                    this.data.filters = [];
                    this.data.currentPage = 1; //reset page to 1
                },  
                populateProducts(productLines) {
                    let productLineStr = decodeURIComponent(productLines.join('|'));
                    // console.log(brandStr);
                    let baseUrl = window.softwareAPIUrl;
                    let apiUrl = `/api/GetSoftwareProductsByBrand`;
                    // let apiUrl = "http://localhost:3003/productsByBrand"; //from json-server
                    let self = this;

                    axios.get(apiUrl, {
                            params: {
                                brand: productLineStr,
                                lang: this.siteLang  
                            }
                        })
                        .then(function(response) {
                            // console.log(response);
                            self.data.products = response.data.results;  
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                },
                
                didYouMean(e) {
                    let didyoumeanEl = document.querySelectorAll('.peoplealsosearchedfor');
                    let didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__peoplealsosearchedfor');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));
                    didyoumeanEl = document.querySelectorAll('.didyoumean');
                    didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__didyoumean');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));
                    //console.log('didYouMean',e);
                    let query;
                    if (e.target) {
                        query = e.target.innerText;
                    } else {
                        query = e;
                    }
                    //console.log('query = ',query, 'e = ', e, e.target);
                    this.data.query = query;
                    //this.updateHistory();
                    document.querySelector('.hero-center__search-input').value = query;
                    this.addLoading();
                    this.getResults();
                },

                getResults(query) {

                    // let apiUrl = "api/documents?";
                    this.data.query = query === null ? null : query ? query : this.data.query;
                    this.data.currentPage = query ? 1 : this.data.currentPage;
                    // this.getUrl();
                    let baseUrl = window.softwareAPIUrl;
                    let apiUrl = `${baseUrl}${baseUrl.indexOf('?') > -1 ? '' : '?'}`;
                    // let apiUrl = "http://localhost:3003/software"; //from json-server
                    // let apiUrlTest = "http://localhost:3003/documentationTest"; //from json-server

                    let self = this;

                    let savedDocumentsTrueParams = () => {
                        var savedOnly = this.data.filters.find(item => {
                            return item.type == "savedSoftware";
                        })
                        if (savedOnly) {
                            return true;
                        } else {
                            return false;
                        }
                    }

                    var product = [];
                    var lang = [];
                    var productLine = [];
                    var downloadType = [];

                    this.data.filters.map((item) => {
                        switch(item.type) {
                            case "product":
                                product.push(item.value);
                                break;
                            case "lang":
                                lang.push(item.value);
                                break;
                            case "productline":
                                productLine.push(item.value);
                                break;
                            case "downloadType":
                                downloadType.push(item.value);
                                break;
                            default:
                                return;
                        }
                    });

                    let productStr = decodeURIComponent(product.join('|'));
                    let langStr = decodeURIComponent(lang.join('|'));
                    let productLineStr = decodeURIComponent(productLine.join('|'));
                    let downloadTypeStr = decodeURIComponent(downloadType.join('|'));

                    let axiosParams = {
                        q: this.data.query ? this.data.query : null,
                        saved: this.data.savedDocs.join('|') == "" ? null : this.data.savedDocs.join('|').charAt(0) == "," ? this.data.savedDocs.join('|').slice(1) : this.data.savedDocs.join('|'), //@TODO make this less insane. Send NULL if empty string. Remove leading comma if present.
                        product: productStr == "" ? null : productStr,
                        language: langStr == "" ? null : langStr,
                        productLine: productLineStr == "" ? null : productLineStr,
                        downloadType: downloadTypeStr == "" ? null : downloadTypeStr,
                        savedSoftware: savedDocumentsTrueParams(),
                        page: this.data.currentPage,
                        lang: this.siteLang ? this.siteLang : window.currentCulture
                    }

                    // console.log(axiosParams);
                    var searchTerm = this.data.query;

                    axios.get(apiUrl,{
                            params: {
                                ...axiosParams
                            }
                        })
                        .then(function(response) {
                            // console.log(response);
///
                            /// Did you mean query logic from episerver find:
                            ///
                            let didyoumeanEl, didyoumeanContainer;
                            if (response.data.results.length == 0) {
                                didyoumeanEl = document.querySelectorAll('.didyoumean');
                                didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__didyoumean');
                            }
                            else {

                                didyoumeanEl = document.querySelectorAll('.peoplealsosearchedfor');
                                didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__peoplealsosearchedfor');
                            }

                            if (response.data.didYouMean && response.data.didYouMean.length > 0) 
                            {
                                let allElements = [];
                                response.data.didYouMean.forEach(dym => {
                                    let anchorElement = document.createElement('a');
                                    anchorElement.href="#";
                                    anchorElement.innerText = dym;
                                    anchorElement.addEventListener("click", function (e) {
                                        e.stopPropagation();
                                        self.didYouMean(anchorElement.innerText);
                                    });
                                    allElements.push(anchorElement);
                                });

                                //clear out all previous elements
                                didyoumeanEl.forEach(parent => {
                                    while (parent.firstChild) {
                                        parent.removeChild(parent.firstChild);
                                    }
                                });
                                //console.log('  --> Appending to ', didyoumeanEl);
                               
                                for (let i = 0; i<allElements.length; i++) {
                                    didyoumeanEl.forEach(el => el.append(allElements[i]));
                                    if (i + 1 < allElements.length) {
                                        var commaEl = document.createElement('span');
                                        commaEl.style.paddingLeft = "7px";
                                        
                                        didyoumeanEl.forEach(el => el.append(commaEl));
                                    }
                                }            
                                didyoumeanContainer.forEach(element => element.classList.add('show'));

                            } else {
                                didyoumeanContainer.forEach(element => element.classList.remove('show'));
                            }
                            ///
                            /// End of did you mean query logic
                            ///

                            // GTM TAGGING
                            if (searchTerm && searchTerm.length > 0 && 
                                window.dataLayer[window.dataLayer.length-1].event != "search-results" // hack to avoid double entry.  this runs twice for some reason
                                ) { // only push if this is a query, not a filter
                                window.dataLayer.push( {
                                    event: "search-results",
                                    type: "software",
                                    category: "Search",
                                    action: searchTerm,
                                    label: response.data.totalResults,
                                });
                            }

                            self.data.results = response.data.results;  
                            self.data.totalResults = response.data.totalResults;
                            self.data.shownResults = response.data.results.length;
                            self.data.trackId = response.data.trackId;
                            
                            self.removeLoading();
                        })
                        .catch(function(error) {
                            console.log(error);
                            self.removeLoading();

                        });
                },
                changePage(dir) {
                    if (dir == "prev" && this.data.currentPage !== 1) {
                        this.data.currentPage--;
                    } else if (dir == "next" && this.data.currentPage !== this.data.totalPages) {
                        this.data.currentPage++;
                    } else {
                        return;
                    }
                    EventBus.$emit('scroll-to-top', this.data.class);
                    this.addLoading();
                    this.getResults();
                },
                
                scrollToTop(el) {
                    if (el !== this.data.class) {return;}
                    let top = this.$el.querySelector('.software__area-cards').getBoundingClientRect().top + window.scrollY - 100;
                    // console.log(top);
                    setTimeout(function() {
                        window.scrollTo({
                            top: top,
                            behavior: 'smooth'
                        });
                    }, 500);
                },
                initPages() {
                    // based on total result count, divide by 10 to get total pages needed
                    // math ceil to round up
                    // set active for prev/next based on current page
                    this.data.totalPages = Math.ceil(this.data.totalResults / 10);
                    this.data.prevActive = this.data.currentPage !== 1 ? true : false;
                    this.data.nextActive = this.data.currentPage !== this.data.totalPages ? true : false;
                },
                addLoading() {
                    this.isLoading = true;

                    let inputField = document.querySelector('.hero-center__search-input-container');
                    inputField.classList.add('loading');
                },
                removeLoading() {
                    this.isLoading = false;

                    let inputField = document.querySelector('.hero-center__search-input-container');
                    inputField.classList.remove('loading');
                },
                init() {
                    this.data.isMobile = store.state.isMobile;
                    this.data.savedDocs = store.state.favorites.softwareId[0] == "" ? store.state.favorites.softwareId.slice(1) : store.state.favorites.softwareId;
                    this.data.filtersVisible = this.data.isMobile ? false : true; //init show/hide filters if/is mobile
                    // listen for filter updates in children
                    EventBus.$on('updateFilters', (el, e, type) => {
                        this.updateFilters(el, e, type);
                    });
                    EventBus.$on('remove-filter', (el, value, type) => {
                        this.removeFilter(el, value, type);
                    });
                    EventBus.$on('change-page-to', (el, num) => {
                        if (el !== this.data.class) {return;};
                        this.data.currentPage = num;
                        this.addLoading();
                        this.getResults();
                    });
                    EventBus.$on('internal-search', (value, type) => {
                        if (type == "software") {
                            let didyoumeanEl = document.querySelectorAll('.peoplealsosearchedfor');
                            let didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__peoplealsosearchedfor');
                            didyoumeanContainer.forEach(element => element.classList.remove('show'));
                            didyoumeanEl = document.querySelectorAll('.didyoumean');
                            didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__didyoumean');
                            didyoumeanContainer.forEach(element => element.classList.remove('show'));
                            this.addLoading();

                            this.getResults(value);
                        }
                    });
                    EventBus.$on('scroll-to-top', (el) => {
                        this.scrollToTop(el);
                    });
                    // init results
                    this.data.results = window.initialSoftwareApiResults.results;
                    this.data.totalResults = window.initialSoftwareApiResults.totalResults;
                    this.data.shownResults = window.initialSoftwareApiResults.results.length;
                    this.data.releaseNotesLabel = window.initialSoftwareApiResults.releaseNotesLabel;

                    // this.data.results = fpodb.software.results;
                    // this.data.totalResults = fpodb.software.totalResults;
                    // this.data.shownResults = fpodb.software.results.length;
                    // this.data.releaseNotesLabel = fpodb.software.releaseNotesLabel;

                    this.data.filterAreaVisible = parseInt(this.data.totalResults) <= 10 ? false : true;

                    // window.onpopstate = () => {
                    //     this.deeplink();
                    // }
                }
            },
            mounted() {
                this.init();
                this.initPages();
                // for deeplinking
                // if (window.location.search) {
                //     this.$nextTick(() => {
                //         this.deeplink();
                //     });
                // }
            }
        });

        Vue.component('software-products', {
            props: ['data', 'category'],
            data: function() {
                return {
                    type: "product"
                }
            },
            components: {
                'checkbox-item': Checkbox
            },
            template: `
            <div class="software__products-content">
                <checkbox-item v-for="(productItem, i) in data.products" :key=i :type="type" :label="productItem.value" :value="productItem.key" :data="data" :category="category"/>
            </div>
            `,
            methods: {
            },

            mounted() {

            }
        });
        
        // results list
        Vue.component('software-results-list', {
            props: ['data', 'isLoading'],
            data: function() {
                return {
                    type: "software"
                }
            },
            template: `
            <div class="software__cards-content" :data="data">
                <software-results-item v-for="(result, index) in data.results" :content="result"  :key="index" :data="data" :isLoading="isLoading" />
            </div>
            `,
            methods: {
            },

            mounted() {

            }
        });

        // single results item
        Vue.component('software-results-item', {
            props: ['data', 'content', 'isLoading'],
            data: function() {
                return {
                    // isChecked: false,
                    isBookmarked: false,
                    id: null
                }
            },
            computed: {
                saved: function() {
                    return store.state.favorites.softwareId;
                },
                tagMetaBody: function() {
                    return JSON.stringify({
                        "type": "app", 
                        "category": this.content.downloadType, 
                        "label": this.content.name, 
                        "productLine": this.content.eyebrow, 
                        "language": this.content.languages.toString()
                    })
                }
            },
            watch: {
                saved: function() {
                    this.isBookmarked = this.saved.includes(this.id) ? true : false;
                },
                "content": function() {
                    this.$nextTick(() => {
                        // console.log(this.$refs.bookmark.dataset.softwareId);
                        this.id = this.$refs.bookmark.dataset.softwareId;
                        this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                        console.log('software-results-item - watch() content -> this', this);
                    })
                }
            },
            template: `
            <div class="software-card" :data="data" :class="{'hide-bookmark': (data.savedDocsOnly === true) && (isBookmarked === false)}" data-tag-trigger="click" :data-tag-meta="tagMetaBody">
                <div class="software-card__wrapper">
                    <div class="software-card__row">
                        <div class="software-card__area software-card__area-left">
                            <span class="software-card__eyebrow">
                                {{content.eyebrow}}
                            </span>
                            <a :href="content.viewDetailsUrl" class="software-card__title" v-if="content.viewDetailsUrl" data-tag-trigger="click" data-tag-meta='{"type": "app", "action": "Details"}'>
                                {{content.name}}
                            </a>
                            <div class="software-card__title" v-if="!content.viewDetailsUrl">
                                {{content.name}}
                            </div>
                            <span class="software-card__subtitle" ref="details">
                                {{content.details}} <span v-if="content.releaseNotes">| </span><a href="#" v-on:click.prevent="triggerModal" v-if="content.releaseNotes">{{data.releaseNotesLabel}} <span class="release-notes" ref="releaseNotes">{{content.releaseNotes}}</span></a>
                            </span>
                        </div>
                        <div class="software-card__area software-card__area-right">
                            <a class="software-card__icon software-card__icon-download" :data-download-url="content.downloadUrl" :data-download-name="content.name" :href="content.downloadHref" data-tag-trigger="click" data-tag-meta='{"type": "app", "action": "Download"}'></a>
                            <a class="software-card__icon software-card__icon-bookmark" ref="bookmark" :data-software-id="content.id" v-on:click.prevent="handleBookmark" :class="{active: isBookmarked}" data-tag-trigger="click" data-tag-meta='{"type": "app", "action": "Favorite"}'></a>
                            <a class="software-card__icon software-card__icon-arrow" :class="{inactive: content.viewDetailsUrl == undefined}" :href="content.viewDetailsUrl" data-tag-trigger="click" data-tag-meta='{"type": "app", "action": "Details"}'></a>
                        </div>
                    </div>
                </div>
            </div>
            `,
            methods: {
                handleBookmark() {
                    store.commit('updateFavorites', {
                        id: this.id,
                        type: "softwareId",
                        action: this.isBookmarked ? "remove" : "add"
                    });
                    store.dispatch('checkFavorites');
                },
                // initReleaseNotes() {
                //     this.$refs.details.addEventListener('click', (e) => {
                //         e.preventDefault();
                //         this.triggerModal();
                //     });
                // },
                triggerModal() {
                    this.$modal.show(
                        releaseNotesModal.template(this.content.releaseNotes),
                        releaseNotesModal.name,
                        releaseNotesModal.options
                    )
                }
            },
            mounted() {
                this.id = this.$refs.bookmark.dataset.softwareId;
                // console.log("saved",this.saved);
                this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                // this.initReleaseNotes();
                let self = this;
                this.$nextTick(() => {
                    let trackId = self.data.trackId;

                    if (trackId) {
                        let hitId = self.content.hitId;
                        let query = self.data.query;
                        let url = `/api/SearchHit?q=${encodeURIComponent(query)}&h=${encodeURIComponent(hitId)}&t=${encodeURIComponent(trackId)}`
                        let allAnchors = self.$el.querySelectorAll('a');
                        allAnchors.forEach(el => el.addEventListener('click', (e) => 
                            axios.get(url)
                            .then(function(response) {
                                //console.log("--> Tracking response: ", response);
                            })
                        ));
                    }
                });

            }
        });

        new Vue({
            el: `.software-${id}`,
            store: store
        }).$mount(`.software-${id}`, true);
    }

    if (software.length > 0) {
        software.forEach((item, index) => {
            item.classList.add(`software-${index}`);
            softwareConstructor(index);
        })
    }

}

export default Software;